import React, { Component } from "react";
import Header from "./Header";

import anime from "animejs/lib/anime.es.js";

class Top extends Component {
  componentDidMount() {
    const text = document.querySelector(".myname");
    console.log(text);
    text.innerHTML = text.textContent.replace(/\S/g, "<span>$&</span>");
    const animation = anime.timeline({
      targets: ".myname span",
      easing: "easeInOutExpo",
      loop: "true",
    });
    let val = [-1, 1];
    animation
      .add({
        opacity: 0,
        rotate: function () {
          return anime.random(-360, 360);
        },
        translateX: function () {
          return val[anime.random(0, 100) % 2] * 1500;
        },
        translateY: function () {
          return val[anime.random(0, 100) % 2] * 1500;
        },
        duration: 200,
        delay: anime.stagger(1),
      })
      .add({
        opacity: 1,
        duration: 10,
      })
      .add({
        rotate: 0,
        translateX: 0,
        translateY: 0,
        duration: 2000,
        delay: anime.stagger(200),
      })
      .add({
        scale: 1.3,
        duration: 700,
        delay: anime.stagger(100),
      })
      .add({
        rotate: function () {
          return anime.random(-5, 5);
        },
        duration: 700,
        delay: anime.stagger(100),
      });
  }
  render() {
    return (
      <div className="header-container">
        <Header />
        <img src="4.gif" className="headerimg"></img>
        <img src="5.gif" className="header2img"></img>
        <div className="myname">Apoorv Jain</div>
        <div className="profile">
          <img src="https://i.ibb.co/Mc5j0Tx/def.jpg"></img>
        </div>
        <div className="ocean">
          <div className="wave"></div>
          <div className="wave"></div>
        </div>
      </div>
    );
  }
}

export default Top;
